import { FormattedMessage } from "react-intl";
import Layout from "../Layout";
import Sidebar, { Menu } from "../Sidebar";

function StartSidebar() {
	return <Sidebar>
		<Menu icon="home" title={<FormattedMessage id="START" />} href="/start" />
		<Menu icon="chalkboard-teacher" title={<FormattedMessage id="BECAME_MENTOR" />} href="/register/mentor" />
		<Menu icon="user-friends" title={<FormattedMessage id="BECAME_MENTEE" />} href="/register/mentee" />
	</Sidebar>;
}

export default function StartHome({ children }) {
	return <Layout sidebar={StartSidebar}>
		{children}
	</Layout>;
}
